import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/table/table-vectometer.svg'


const _withScopeId = n => (_pushScopeId("data-v-fd1b5fea"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-100",
  src: _imports_0
}, null, -1))
const _hoisted_2 = { class: "pool-list__active-stake-progress" }
const _hoisted_3 = { class: "pool-list__active-stake-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_AmountText = _resolveComponent("AmountText")!
  const _component_a_progress = _resolveComponent("a-progress")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock(_component_Table, {
    "table-layout": "auto",
    columns: _ctx.columns,
    "data-source": _ctx.tableDataSource,
    "is-loading": _ctx.isLoading,
    "is-show-more-loading": _ctx.showMoreIsLoading,
    loadMore: _ctx.showMore,
    "custom-row": 
      (record) => ({
        onClick: () => _ctx.gotoPoolDetails(record.hash, false),
        onauxclick: `gotoPoolDetails('${record.hash}',true)`,
      })
    
  }, {
    pool: _withCtx((items) => [
      _createVNode(_component_a_row, {
        class: "pool-list__pool-item",
        align: "middle",
        wrap: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_avatar, {
            class: "mr-8",
            style: _normalizeStyle({
            color: `${_ctx.randomAvatarColor().color}`,
            backgroundColor: `${_ctx.randomAvatarColor().backgroundColor}`,
          })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(items.record.pool.avatar), 1)
            ]),
            _: 2
          }, 1032, ["style"]),
          _createTextVNode(" " + _toDisplayString(items.record.pool.name), 1)
        ]),
        _: 2
      }, 1024)
    ]),
    profit: _withCtx((items) => [
      _createVNode(_component_a_col, {
        lg: 0,
        md: 0,
        xl: 0,
        class: "pool-list__table-item-mobile-label"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("Live Stake")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, {
        align: "middle",
        wrap: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            span: 3,
            class: "mr-8 flex-full-center hide-if-collapsed"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, {
                align: "middle",
                wrap: false
              }, {
                default: _withCtx(() => [
                  (items.record.profit.liveValue)
                    ? (_openBlock(), _createBlock(_component_AmountText, {
                        key: 0,
                        class: "d-inline",
                        amount: items.record.profit.liveValue,
                        minPrecision: 2,
                        "max-precision": 2,
                        unit: "%"
                      }, null, 8, ["amount"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    activeStake: _withCtx((items) => [
      _createVNode(_component_a_col, {
        lg: 0,
        md: 0,
        xl: 0,
        class: "pool-list__table-item-mobile-label"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("Active Stake")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_progress, {
          "stroke-color": {
            '0%': _ctx.lessVariable.customColor7,
            '100%': _ctx.lessVariable.primaryColor,
          },
          percent: items.record.activeStake.percent,
          showInfo: false,
          status: "active"
        }, null, 8, ["stroke-color", "percent"]),
        _createElementVNode("div", _hoisted_3, [
          (items.record.activeStake.amount)
            ? (_openBlock(), _createBlock(_component_AmountText, {
                key: 0,
                amount: items.record.activeStake.amount,
                minPrecision: 0,
                unit: "₳"
              }, null, 8, ["amount"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    defaultNumberDisplay: _withCtx((items) => [
      _createVNode(_component_a_col, {
        class: "pool-list__table-item-mobile-label",
        lg: 0,
        md: 0,
        xl: 0
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.tableItemMobileLabel[items.column.key]), 1)
        ]),
        _: 2
      }, 1024),
      (items?.text)
        ? (_openBlock(), _createBlock(_component_AmountText, {
            key: 0,
            amount: items.text,
            minPrecision: 0,
            unit: items?.column?.unit
          }, null, 8, ["amount", "unit"]))
        : _createCommentVNode("", true)
    ]),
    defaultPercentNumberDisplay: _withCtx((items) => [
      _createVNode(_component_a_col, {
        class: "pool-list__table-item-mobile-label",
        lg: 0,
        md: 0,
        xl: 0
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.tableItemMobileLabel[items.column.key]), 1)
        ]),
        _: 2
      }, 1024),
      (items?.text)
        ? (_openBlock(), _createBlock(_component_AmountText, {
            key: 0,
            amount: items.text,
            minPrecision: 2,
            "max-precision": 2,
            unit: "%"
          }, null, 8, ["amount"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "data-source", "is-loading", "is-show-more-loading", "loadMore", "custom-row"]))
}